import React, { useState } from "react";
import axios from "axios";
import "./SignatureRecipientsForm.scss";
import { BASE_URL } from "config/config";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function SignatureRecipientsForm({
  documentId,
  onSuccess,
  onUploadSuccess,
  documentPreview = null, // Add document preview prop
  showRecipientsSuccessPopup,
  setShowRecipientsSuccessPopup,
}) {
  const [recipients, setRecipients] = useState([]);
  const [error, setError] = useState("");
  const [sendWithOrder, setSendWithOrder] = useState(true); // Default to true as in screenshot
  const [btn, setBtn] = useState(false);
  const [showRecipients, setShowRecipients] = useState(true);
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;
  console.log(companyId);
  const handleChange = (index, field, value) => {
    const updated = [...recipients];
    if (field === "order") updated[index][field] = Number(value);
    else if (field === "signe") updated[index][field] = value === "true";
    else updated[index][field] = value;
    setRecipients(updated);
  };

  const addRecipient = () => {
    setRecipients([
      ...recipients,
      { name: "", email: "", order: recipients.length + 1, signe: true },
    ]);
  };

  const removeRecipient = (index) => {
    setRecipients(recipients.filter((_, i) => i !== index));
  };

  const validate = () => {
    for (const r of recipients) {
      if (!r.name.trim() || !r.email.trim()) {
        setError(t("signature.tousRempli"));
        return false;
      }
      if (!/\S+@\S+\.\S+/.test(r.email)) {
        setError(`Email invalide: ${r.email}`);
        return false;
      }
      if (sendWithOrder && (!r.order || r.order < 1)) {
        setError(t("signature.orderValide"));
        return false;
      }
    }

    if (sendWithOrder) {
      const orders = recipients.map((r) => r.order);
      const uniqueOrders = new Set(orders);
      if (orders.length !== uniqueOrders.size) {
        setError(t("signature.orderUnique"));
        return false;
      }
    }

    setError("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    if (!documentId) {
      setError(t("signature.docNonCharge"));
      return;
    }
    try {
      let finalRecipients = [...recipients];
      if (sendWithOrder) {
        finalRecipients = finalRecipients.sort((a, b) => a.order - b.order);
      }

      const res = await axios.post(`${BASE_URL}signatures/create`, {
        documentId,
        recipients: finalRecipients,
        sendWithOrder,
        companyId: companyId,
      });

      onUploadSuccess(res?.data?.data);
      setError("");
      if (onSuccess) onSuccess();
      setBtn(true);
      setShowRecipientsSuccessPopup(true);
    } catch (e) {
      setError(t("signature.errorEnreg"));
    }
  };

  return (
    <div className="signature-form-container">
      {/* Document Preview Section */}
     

      {/* Recipients Section */}
      <div className="recipients-section">
        <div className="recipients-header" onClick={() => setShowRecipients(!showRecipients)}>
          <h2>Ajouter des destinataires</h2>
          <svg 
            className={`chevron ${showRecipients ? 'up' : 'down'}`} 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none"
          >
            <path d="M4 6L8 10L12 6" stroke="#0f84ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {showRecipients && (
          <div className="recipients-content">
            {/* Signatory Options */}
            <div className="signatory-options">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={sendWithOrder}
                  onChange={(e) => setSendWithOrder(e.target.checked)}
                />
                <span className="checkmark"></span>
                Définir l'ordre de signature
                <span className="show-link">Afficher</span>
              </label>
            </div>

            {/* Recipients List */}
            {recipients.map((r, i) => (
              <div key={i} className="recipient-card">
                {sendWithOrder && (
                  <input
                    type="number"
                    value={r.order}
                    onChange={(e) => handleChange(i, "order", e.target.value)}
                    className="recipient-order-input"
                    min="1"
                    placeholder="Ordre"
                  />
                )}
                <div className="recipient-fields">
                  <div className="field-group">
                    <div className="input-with-icon">
                      <svg className="input-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z" fill="#666"/>
                        <path d="M0 16C0 12.6863 2.68629 10 6 10H10C13.3137 10 16 12.6863 16 16V18H0V16Z" fill="#666"/>
                      </svg>
                      <input
                        type="text"
                        placeholder="Prénom et Nom *"
                        value={r.name}
                        onChange={(e) => handleChange(i, "name", e.target.value)}
                        className="name-input"
                      />
                    </div>
                    <div className="input-with-icon">
                      <svg className="input-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M2 4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4Z" stroke="#666" strokeWidth="1" fill="none"/>
                        <path d="M3 5L8 9L13 5" stroke="#666" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <input
                        type="email"
                        placeholder="E-mail *"
                        value={r.email}
                        onChange={(e) => handleChange(i, "email", e.target.value)}
                        className="email-input"
                      />
                    </div>
                  </div>
                  <div className="recipient-actions">
                    <select
                      value={r.signe}
                      onChange={(e) => handleChange(i, "signe", e.target.value)}
                      className="sign-select"
                    >
                      <option value={true}>Doit signer</option>
                      <option value={false}>En copie</option>
                    </select>
                    
                    {recipients.length > 1 && (
                      <button
                        onClick={() => removeRecipient(i)}
                        className="delete-button"
                        title="Supprimer ce destinataire"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.912 4L14.111 17.617C14.0812 18.1264 13.8577 18.6051 13.4865 18.9551C13.1153 19.3052 12.6243 19.5001 12.114 19.5H4.886C4.37575 19.5001 3.88475 19.3052 3.5135 18.9551C3.14226 18.6051 2.91885 18.1264 2.889 17.617L2.09 4H0V3C0 2.86739 0.0526785 2.74021 0.146447 2.64645C0.240215 2.55268 0.367392 2.5 0.5 2.5H16.5C16.6326 2.5 16.7598 2.55268 16.8536 2.64645C16.9473 2.74021 17 2.86739 17 3V4H14.912ZM6.5 0H10.5C10.6326 0 10.7598 0.0526785 10.8536 0.146447C10.9473 0.240215 11 0.367392 11 0.5V1.5H6V0.5C6 0.367392 6.05268 0.240215 6.14645 0.146447C6.24021 0.0526785 6.36739 0 6.5 0ZM5.5 6.5L6 15.5H7.5L7.1 6.5H5.5ZM10 6.5L9.5 15.5H11L11.5 6.5H10Z"
                            fill="#dc2626"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {/* Add Recipient Button */}
            <button onClick={addRecipient} className="add-recipient-button">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 2V14M2 8H14" stroke="#0f84ff" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Ajouter un destinataire
            </button>

            {/* Error Display */}
            {error && <div className="error-message">{error}</div>}

            {/* Submit Button */}
            <div className="submit-section">
              {!btn ? (
                <button className="submit-button" onClick={handleSubmit}>
                  {t("signature.enregiestrer")}
                </button>
              ) : (
                <button className="submit-button disabled" disabled>
                  {t("signature.enregiestrer")}
                </button>
              )}
            </div>
          </div>
        )}
      </div>

    </div>
  );
}
